import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import GuestPreferenceModal from './GuestPrefrenceModal'; 
import { toast } from "react-toastify"; // ✅ Only toast is needed


const GuestPreferences = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    const [preferences, setPreferences] = useState([]);
    const [filteredPreferences, setFilteredPreferences] = useState(preferences);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
      const [editingIndex, setEditingIndex] = useState(null);
        const [modalValue, setModalValue] = useState('');

                const BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const filtered = preferences.filter((item) =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredPreferences(filtered);
        setCurrentPage(1);
    }, [searchQuery, preferences]);

    const totalPages = Math.ceil(filteredPreferences.length / itemsPerPage);
    const currentData = filteredPreferences.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    useEffect(() => {
    const fetchPreferences = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/guest-preferences`);
            const data = await res.json();
            setPreferences(data);
        } catch (err) {
            console.error("Failed to load guest preferences:", err);
        }
    };

    fetchPreferences();
}, []);


 const handleDelete = async (indexInPage) => {
    const actualIndex = (currentPage - 1) * itemsPerPage + indexInPage;
    const preferenceToDelete = preferences[actualIndex];

    if (!window.confirm(`Are you sure you want to delete "${preferenceToDelete.name}"?`)) return;

    try {
        const res = await fetch(`${BASE_URL}/api/guest-preferences/${preferenceToDelete.id}`, {
            method: 'DELETE',
        });

        if (!res.ok) throw new Error('Failed to delete preference');

        const updated = preferences.filter((_, index) => index !== actualIndex);
        setPreferences(updated);
                toast.success(`"${preferenceToDelete.name}" deleted successfully!`); // ✅ Success Toast

    } catch (err) {
        console.error('Error deleting preference:', err);
        toast.error('Failed to delete preference');
    }
};


     const openAddModal = () => {
        setEditingIndex(null);
        setModalValue('');
        setIsModalOpen(true);
    };

    const openEditModal = (index) => {
        setEditingIndex(index);
        setModalValue(preferences[index].name);
        setIsModalOpen(true);
    };

  const handleModalSubmit = async (value) => {
    if (!value.trim()) return;

    try {
        if (editingIndex !== null) {
            const preferenceToUpdate = preferences[editingIndex];

            const res = await fetch(`${BASE_URL}/api/guest-preferences/${preferenceToUpdate.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!res.ok) throw new Error("Failed to update preference");

            const updated = await res.json();
            const updatedList = [...preferences];
            updatedList[editingIndex] = updated;
            setPreferences(updatedList);
             toast.success(`"${value.trim()}" updated successfully!`); // 
        } else {
            const res = await fetch(`${BASE_URL}/api/guest-preferences`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!res.ok) throw new Error("Failed to create preference");

            const created = await res.json();
            setPreferences([...preferences, created]);
                        toast.success(`"${value.trim()}" added successfully!`); // ✅ Success Toast

        }

        setIsModalOpen(false);
        setEditingIndex(null);
        setModalValue('');
    } catch (err) {
        console.error("Error saving preference:", err);
        toast.error("Something went wrong!"); // ✅ Error Toast
    }
};


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Guest Preferences</h1>
                    <button className="oms-add-btn" onClick={openAddModal}>
                        Add Preference
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search guest preference..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ minWidth: '200px' }}>Preference Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((pref, index) => (
                                    <tr key={index}>
                                        <td>{pref.name}</td>
                                        <td>
                                            <button className="edit-button" onClick={() => openEditModal(index)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center' }}>
                                        No guest preferences found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

            <GuestPreferenceModal   
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                initialValue={modalValue}
                onSubmit={handleModalSubmit}
            />
        </>
    );
};

export default GuestPreferences;
